'use client';
import React from 'react';
import { Layout } from 'antd';
import styles from './OurProducts.module.scss';
import { OUR_PRODUCTS_DATA } from './constants';
import { ProductCard } from './ui/ProductCard';
import { useTranslations } from 'next-intl';

const { Content } = Layout;

export function OurProducts() {
  const t = useTranslations('ourProducts');
  return (
    <Content className={styles.root} id="ourProducts">
      <section className={styles.root_container}>
        <div className={styles.root_container_line}/>
        <h2>{t('title')}</h2>
        <h3>{t('subtitle')}</h3>
      </section>
      {OUR_PRODUCTS_DATA.map((item, index) => (
        <ProductCard {...item} side={index % 2 === 0 ? 'left' : 'right'} key={String(item.id)}/>
      ))}
    </Content>
  );
}
